module.exports = __webpack_public_path__ + "static/img/banner_new1.0eaa466.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/banner/banner_new1.jpg
// module id = VXT7
// module chunks = 0